<form [formGroup]="formGroup">
  <div class="d-flex flex-column">
    <div class="field-container">
      <h3> {{'createProposal.riskDataQuestion'|translate}}</h3>
    </div>
      <app-input-field [control]="formGroup.controls.coveragePercentageRequested"
                       class="field-container w-20"
                       [label]="'createProposal.requestedPercentage'|translate"
      >
        <input name="coveragePercentageRequested"
               appNumberFormat
               [maxNumber]="100"
               formControlName="coveragePercentageRequested"
               class="input">
      </app-input-field>

    <div class="field-container" [formGroup]="formGroup" *ngIf="formGroup.controls.coveragePercentageRequested.value < 100">
      <span class="small-text">
        {{'createProposal.requestedRoles'|translate}}{{"*"}}
      </span>
      <div>
        <mat-checkbox formControlName="leadInsurerNeeded" (change)="onRoleChange('leadInsurerNeeded')">
          {{'createProposal.leader'|translate}}
        </mat-checkbox>
      </div>
      <div>
      <mat-checkbox formControlName="followingInsurerNeeded" (change)="onRoleChange('followingInsurerNeeded')">
          {{'createProposal.follower'|translate}}
        </mat-checkbox>
      </div>
    </div>

    <app-input-field [control]="formGroup.controls.lineOfBusiness" class="field-container"
                     [label]="'createProposal.lineOfBusiness'|translate">
      <mat-select formControlName="lineOfBusiness"
                  class="input"
                  [value]="formGroup.controls.lineOfBusiness" #singleSelect>
        <mat-option>
          <ngx-mat-select-search [formControl]="filterCtrlLineOfBusiness" ngDefaultControl></ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredOptionsLineOfBusiness |async" [value]="opt">
          {{'lineOfBusiness.clauses.' + opt + '.name' | translate}}
        </mat-option>

      </mat-select>
    </app-input-field>

    <div class="d-flex justify-content-between field-container">
      <app-input-field [control]="this.formGroup.controls.riskDateBegin" class="even-input"
                       [label]="'createProposal.beginDate'|translate"
                       [labelForErrorMessage]="'createProposal.endDate'|translate"
                       [highlightField]="dateBeforeValidation()">
        <!--riskDateEnd calls riskDateBegin to revalidate with new end date-->
        <input (input)="calculateDurationInMonths()"
               formControlName="riskDateBegin" name="riskDateBegin" class="input"
               type="date">
      </app-input-field>
      <app-input-field [control]="formGroup.controls.riskDateEnd" class="even-input"
                       [label]="'createProposal.endDate'|translate"
                       [highlightField]="dateBeforeValidation()">
        <input (input)="calculateDurationInMonths()"
               name="riskDateEnd" formControlName="riskDateEnd"
               class="input"
               type="date">
      </app-input-field>
    </div>

    <div
      *ngIf="duration != null && duration > 1"
      class="durationSubtitle">{{'createProposal.durationInMonths'|translate:{months: duration} }} <br>
      <br></div>
    <div
      *ngIf="duration != null && duration === 1"
      class="durationSubtitle">{{'createProposal.durationInMonth'|translate:{months: duration} }}<br>
      <br></div>
    <app-input-field [control]="formGroup.controls.mainDueDate" class="field-container"
                     [label]="'createProposal.mainDueDate'|translate">
      <mat-select formControlName="mainDueDate"
                  class="input">
        <mat-option>{{'createProposal.emptyOption'|translate}}</mat-option>
        <mat-option *ngFor="let opt of months"
                    [value]="opt">{{'createProposal.monthOptions.' + opt | translate}}</mat-option>
      </mat-select>
    </app-input-field>

    <app-input-field [control]="formGroup.controls.paymentMethod" class="field-container"
                     [label]="'createProposal.paymentMethod'|translate">
      <mat-select formControlName="paymentMethod"
                  class="input">
                  <mat-option>{{'createProposal.emptyOption'|translate}}</mat-option>
        <mat-option *ngFor="let opt of QuestionOptions.paymentMethod"
                    [value]="opt">{{'createProposal.paymentMethodOptions.' + opt | translate}}</mat-option>
      </mat-select>
    </app-input-field>
  </div>
</form>
